interface LoadingSpinnerProps {
  message?: string;
  size?: number;
  fullScreen?: boolean;
}

export default function LoadingSpinner({
  message,
  size = 40,
  fullScreen = false,
}: LoadingSpinnerProps) {
  const content = (
    <div className="app-loading" role="status" aria-live="polite">
      <span className="app-loading__spinner" style={{ width: size, height: size }} aria-hidden="true" />
      {message && <span className="app-loading__message">{message}</span>}
    </div>
  );

  if (fullScreen) {
    return <div className="app-loading-overlay">{content}</div>;
  }

  return content;
}
